import { PipeTransform } from '@angular/core';
var OrderByPipe = /** @class */ (function () {
    function OrderByPipe() {
    }
    OrderByPipe.prototype.transform = function (array, orderField, descending) {
        array.sort(function (a, b) {
            var ae = a[orderField];
            var be = b[orderField];
            if (ae === undefined && be === undefined) {
                return 0;
            }
            if (ae === undefined && be !== undefined) {
                return descending ? 1 : -1;
            }
            if (ae !== undefined && be === undefined) {
                return descending ? -1 : 1;
            }
            if (ae === be) {
                return 0;
            }
            // tslint:disable-next-line:max-line-length
            return descending ? (ae.toString().toLowerCase() > be.toString().toLowerCase() ? -1 : 1) : (be.toString().toLowerCase() > ae.toString().toLowerCase() ? -1 : 1);
        });
        return array;
    };
    return OrderByPipe;
}());
export { OrderByPipe };
